import type {ScannedVersionJobsResult} from "./3-ScanJobs.ts";
import type {
    DriverScanResult,
    EnvironmentScanResult,
    ScannedResultData,
    ScannedResultProjectRow,
    ScannedResultVersionRow,
    ScanResult, SupportInfoScan
} from "../scan-model/ScanResult.tsx";
import type {VersionId} from "./2-ScanVersions.tsx";
import type {ScanContext} from "../scan-model/ScanContext.tsx";
import type {OverallTaskHistoryResult} from "../scan-model/GroupedTaskBatchesScanResult.tsx";
import {mergeProblemResults, blankProblem} from "./job/mergeProblems.tsx";
import type {SharedJobScanResult} from "../scan-model/SharedJobResult.ts";
import {
    generateSharedJobMigrationJson
} from "../../5-download-artifacts/artifacts/shared-pipelines/generateSharedJobMigrationJson.ts";

function getProjectRow(existing: ScannedResultProjectRow[], versionId: VersionId): ScannedResultProjectRow {
    const existingRow = existing.find(s => s.groupName === versionId.groupName && s.projectName === versionId.projectName)
    if(existingRow !== undefined) return existingRow
    const newRow: ScannedResultProjectRow = {
        groupName: versionId.groupName,
        projectName: versionId.projectName,
        problemIndicators: blankProblem(),
        componentCount: {}
    }
    existing.push(newRow)
    return newRow
}

export function mergeResults(cxt: ScanContext,
                             jobsResult: ScannedVersionJobsResult[],
                             taskHistoryResult: OverallTaskHistoryResult | undefined,
                             driversScan: DriverScanResult | undefined,
                             scannedEnvironments: EnvironmentScanResult[] | undefined,
                             sharedJobsResult: SharedJobScanResult,
                             supportInfo: SupportInfoScan,
                             optionalInfo: Partial<ScanResult>
): ScanResult {
    const {log, startAction, dataWarehouse, version, scanErrors, options} = cxt
    log("Merging results")
    const {reportOne, complete} = startAction(`Analyzing and aggregating  results`, jobsResult.length)
    const result: ScannedResultData = {
        componentCount: {},
        problemIndicators: blankProblem(),
        byProject: [],
        byVersion: []
    }
    jobsResult.forEach((versionJobResult) => {
        const projectRow = getProjectRow(result.byProject, versionJobResult.versionId)
        const versionRow: ScannedResultVersionRow = {
            problemIndicators: blankProblem(),
            componentCount: {},
            versionId: versionJobResult.versionId,
            jobs: versionJobResult.jobs
        }
        mergeProblemResults(versionJobResult.jobs, versionRow)
        mergeProblemResults(versionJobResult.jobs, projectRow)
        mergeProblemResults(versionJobResult.jobs, result)
        result.byVersion.push(versionRow)
        reportOne()
    })
    complete()
    return {
        taskHistory: taskHistoryResult,
        jobScan: result,
        sharedJobs: sharedJobsResult,
        sharedJobsMapping: ("jobs" in sharedJobsResult) ? generateSharedJobMigrationJson(sharedJobsResult) : undefined,
        driversScan,
        environmentScan: scannedEnvironments,
        dataWarehouse, version, supportInfo, scanErrors, options, ...optionalInfo
    }
}